/**
 * Home editorial — fade-in-up via IntersectionObserver
 */
(function () {
  var main = document.getElementById('main');
  if (!main || !main.classList.contains('home-editorial')) return;

  function reveal(section) {
    if (!section || !section.classList.contains('shopify-section') || section.classList.contains('shopify-section--footer')) return;
    section.classList.add('is-visible');
  }

  var sections = main.querySelectorAll(':scope > .shopify-section:not(.shopify-section--footer)');
  if (!sections.length && !(window.Shopify && Shopify.designMode)) return;

  if (window.Shopify && Shopify.designMode) {
    sections.forEach(reveal);
    document.addEventListener('shopify:section:load', function (event) {
      reveal(event.target);
    });
    return;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    sections.forEach(function (section) {
      section.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.05 }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });
})();
